export const baixarComprovante = async (
    conteudo,
    nome = 'comprovante',
    tipo = ''
) => {
    if (!conteudo) return;

    const resposta = await fetch(conteudo);
    const arquivo = await resposta.blob();
    const url = URL.createObjectURL(arquivo);
    const link = document.createElement('a');
    const mime = tipo || arquivo.type || '';
    const extensao = mime === 'application/pdf'
        ? '.pdf'
        : mime.startsWith('image/')
            ? `.${mime.split('/')[1].replace('jpeg', 'jpg')}`
            : '';
    const nomeSeguro = (nome || 'comprovante')
        .replace(/[\\/:*?"<>|]/g, '_');

    link.href = url;
    link.download = nomeSeguro.includes('.')
        ? nomeSeguro
        : `${nomeSeguro}${extensao}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
